<template>
    <button
        :disabled="disabled"
        class="border text-white px-4 py-2 duration-300 hover:bg-white hover:scale-105 hover:translate-y-[-2px] flex flex-row justify-center items-center select-none"
        :class="buttonClass">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "Button",
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        Color: {
            type: String,
            default: "main"
        },
        HoverColor: {
            type: String,
            default: ""
        },
        Rounded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonClass() {
            let Classes = [];
            Classes.push(`bg-${this.Color}`);
            Classes.push(`border-${this.Color}`);
            if(this.HoverColor){
                Classes.push(`hover:bg-${this.HoverColor}`);
                Classes.push(`hover:border-${this.HoverColor}`);
                Classes.push(`hover:text-${this.HoverColor}`);
            }else{
                Classes.push(`hover:bg-${this.Color}`);
                Classes.push(`hover:border-${this.Color}`);
                Classes.push(`hover:text-${this.Color}`);
            }
            if(this.Rounded){
                Classes.push(`rounded-lg`);
            }
            return Classes;
        }
    }
}
</script>